<template>
    <option value="verizon">Verizon</option>
    <option value="att">AT&amp;T</option>
    <option value="hologram">Hologram</option>
    <option value="other">Other</option>
</template>
